import React, { useCallback, useRef } from "react";

import { ButtonColor, Load } from "ui/styled";

// 🔒 2026-08-14 — TRAVA CONTRA CLIQUE DUPLO.
//
// Uma cliente clicou duas vezes em "Finalizar Compra" e foi cobrada duas
// vezes (R$ 45,80), com duas assinaturas ativas. O motivo estava aqui: este
// botao troca o texto por uma bolinha girando quando `loading` e verdadeiro,
// mas continuava aceitando clique. Para quem esta do outro lado, parece que
// nao funcionou — e a pessoa clica de novo.
//
// (E o `ButtonColor` e uma <div>, entao o atributo `disabled` do HTML nao
// tem efeito nenhum sobre ele. A barreira precisa estar no clique.)
//
// Sao tres camadas, da mais forte para a mais fraca:
//  1. `ocupado` — enquanto a acao anterior nao termina, nada passa. Vale
//     quando o onClick devolve uma promessa (as acoes que chamam o servidor).
//  2. `loading` — quem ja controla esse estado continua protegido.
//  3. ESPERA — um intervalo curto entre dois cliques aceitos. Cobre as acoes
//     que NAO devolvem promessa. 600 ms fica acima do duplo-clique acidental
//     (que costuma ser menos de 300 ms) e bem abaixo do tempo de quem clica
//     de proposito duas vezes seguidas — "Avancar" num formulario, por
//     exemplo, exige ler a proxima etapa antes.
const ESPERA = 600;

export default function Button({ children, loading, onClick, ...props }){

    const ocupado = useRef(false);
    const ultimoClique = useRef(0);

    const clicar = useCallback(async (event) => {
        if (!onClick || loading || ocupado.current) return;

        const agora = Date.now();
        if (agora - ultimoClique.current < ESPERA) return;
        ultimoClique.current = agora;

        ocupado.current = true;
        try {
            await onClick(event);
        } finally {
            ocupado.current = false;
        }
    }, [onClick, loading]);

    return (
        <>
          <ButtonColor
            {...props}
            onClick={onClick ? clicar : undefined}
            aria-busy={loading ? "true" : undefined}
            style={ loading ? { ...(props.style || {}), pointerEvents: "none" } : props.style }
          >
            {
              loading ? <Load /> : <>
                { children }
              </>
            }
          </ButtonColor>
        </>
    );
  }
